import { render } from "./ChatInput.vue?vue&type=template&id=b254d4b4&ts=true"
import script from "./ChatInput.vue?vue&type=script&lang=ts"
export * from "./ChatInput.vue?vue&type=script&lang=ts"

import "./ChatInput.vue?vue&type=style&index=0&id=b254d4b4&lang=scss"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__